;(function module() {
  angular.module('app.ui.form.ctrls').controller('EmployersListingController', [
    'logger',
    'EmployersApi',
    'SharedApi',
    'PositionApi',
    '$scope',
    '$window',
    '$log',
    '$uibModal',
    'userService',
    'CandidateProfileApi',
    'socket',
    '$rootScope',
    '$compile',
    function controller(
      logger,
      EmployersApi,
      SharedApi,
      PositionApi,
      $scope,
      $window,
      $log,
      $uibModal,
      userService,
      CandidateProfileApi,
      socket,
      $rootScope
    ) {
      let vm = this

      socket.on('EMPLOYER_CREATE', async employerId => {
        const {data: newEmployer} = await EmployersApi.getEmployerListing({
          id: employerId,
        })

        const updatedEmployerIndex = vm.employerListing.findIndex(
          ({id}) => id === employerId
        )
        const formatEmployer = setEmployersListingData(newEmployer)
        if (updatedEmployerIndex >= 0) {
          vm.employerListing[updatedEmployerIndex] = formatEmployer[0]
          vm.gridOptions.api.updateRowData({update: formatEmployer})
        } else {
          vm.employerListing = [...vm.employerListing, ...newEmployer]
          vm.gridOptions.api.updateRowData({
            addIndex: 0,
            add: formatEmployer,
          })
        }

        updateGridGroupPipeline()
      })

      socket.on('EMPLOYER_UPDATE', async employerId => {
        const {data: updatedEmployer} = await EmployersApi.getEmployerListing({
          id: employerId,
        })

        const formatEmployer = setEmployersListingData(updatedEmployer)

        const updatedEmployerIndex = vm.employerListing.findIndex(
          ({id}) => id === employerId
        )
        vm.employerListing[updatedEmployerIndex] = formatEmployer[0]
        vm.gridOptions.api.updateRowData({update: formatEmployer})

        updateGridGroupPipeline()
      })

      socket.on('EMPLOYER_ASSIGNED_AGENT_UPDATE', async employerId => {
        const {data: updatedEmployer} = await EmployersApi.getEmployerListing({
          id: employerId,
        })

        const formatEmployer = setEmployersListingData(updatedEmployer)

        const updatedEmployerIndex = vm.employerListing.findIndex(
          ({id}) => id === employerId
        )
        vm.employerListing[updatedEmployerIndex] = formatEmployer[0]
        vm.gridOptions.api.updateRowData({update: formatEmployer})

        updateGridGroupPipeline()
      })

      socket.on('EMPLOYER_DELETE', async employerId => {
        const deletedEmployer = vm.employerListing.filter(
          ({id}) => id === employerId
        )
        vm.employerListing = vm.employerListing.filter(
          ({id}) => id !== employerId
        )
        vm.gridOptions.api.updateRowData({remove: deletedEmployer})

        updateGridGroupPipeline()
        $rootScope.$broadcast('employer-deleted', {
          employerDeleted: employerId,
        })
      })

      socket.on('POSITION_CREATE', async positionId => {
        const {data: positionCreated} = await PositionApi.getPositionById(
          positionId
        )
        const updatedEmployerIndex = vm.employerListing.findIndex(
          ({id}) => id === positionCreated.employerId
        )

        vm.employerListing[updatedEmployerIndex].positionCount =
          Number.parseInt(
            vm.employerListing[updatedEmployerIndex].positionCount,
            10
          ) + 1

        vm.gridOptions.api.updateRowData({
          update: [...vm.employerListing[updatedEmployerIndex]],
        })

        updateGridGroupPipeline()
      })
      const columnDefs = [
        {
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          width: 60,
          filter: false,
          resizable: false,
        },
        {
          headerName: '',
          field: '',
          filter: false,
          width: 60,
          resizable: false,
          cellRenderer: parameters => {
            return parameters.data.isDeleted
              ? `<center class=""><i class="fa fa-pencil disabled-icon"></i></center>`
              : `<center class=""><i class="fa fa-pencil pointer"></i></center>`
          },
          onCellClicked: openEditEmployerModal,
        },
        {
          headerName: ' Assigned Agent ',
          field: 'employerAgentEmail',
          editable: true,
          cellEditor: 'agRichSelectCellEditor',
          onCellValueChanged: onAgentChange,
          cellEditorParams: {
            values: [],
          },
          cellClass: 'cellEditable',
        },
        {
          headerName: 'Notes',
          columnGroupShow: undefined,
          field: 'notes',
          filter: false,
          resizable: false,
          width: 110,
          cellStyle: {
            background: '#95288f !important',
            color: '#fff',
            text: 'center',
          },
          cellRenderer: () => {
            return `View`
          },
          onCellClicked: openNotesPage,
        },
        {
          headerName: 'Employer Id',
          field: 'id',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Employer Name',
          filter: 'agTextColumnFilter',
          field: 'name',
          cellRenderer: parameters => {
            return parameters.data.employerLogo
              ? `<img src=` +
                  parameters.data.employerLogo +
                  ` style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ` +
                  parameters.value +
                  `</span>`
              : `<img src="/images/firmlogo_Default.png" style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ` +
                  parameters.value +
                  `</span>`
          },
        },
        {
          headerName: 'Category',
          field: 'category',
        },
        {
          headerName: 'Selectivity',
          field: 'selectivity',
        },
        {
          headerName: 'Target Hours',
          field: 'targetHours',
        },
        {
          headerName: 'Size',
          field: 'size',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: ' Turnover (£)',
          field: 'associatesPerPartner',
        },
        {
          headerName: 'Per Equity Profit',
          field: 'profitPerEquityPartner',
        },
        {
          headerName: 'Positions',
          field: 'positionCount',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Candidates Employed',
          field: 'candidateEmployerCount',
          filter: 'agTextColumnFilter',
          cellRenderer: parameter => {
            return parameter.data.candidateEmployerCount
              ? `<center class=""><a href='/admin/lawyer-listing?filterName=currentExperience.employer.name&filterValue=${parameter.data.id}' style="color: #1a78cf;" target="_blank">
              ${parameter.data.candidateEmployerCount} </a></center>`
              : `<center class="">${parameter.data.candidateEmployerCount}</center>`
          },
        },
        {
          headerName: 'Visibility',
          field: 'isVisible',
        },
      ]

      const gridOptions = {
        defaultColDef: {
          sortable: true,
          filter: true,
          enablePivot: true,
          enableRowGroup: true,
          enableValue: true,
          columnGroupShow: 'open',
          resizable: true,
          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        },
        groupRowRenderer: 'agGroupCellRenderer',
        groupRowRendererParams: {
          checkbox: true,
        },
        floatingFilter: true,
        groupDefaultExpanded: -1,
        groupUseEntireRow: true,
        columnDefs: columnDefs,
        animateRows: true,
        getRowNodeId: function(data) {
          return data.id
        },
        enableCellChangeFlash: true,
        groupSelectsChildren: true,
        rowData: vm.employerListing,
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        rowGroupPanelShow: 'always',
        pivotPanelShow: 'always',
        groupSelectsFiltered: true,
        onFilterChanged: onFilterChanged,
        onSelectionChanged: onSelectionChanged,
        onGridReady: function() {
          initializeEmployersListing()
        },
        sideBar: {
          toolPanels: ['columns', 'filters'],
          defaultToolPanel: false,
        },
        statusBar: {
          statusPanels: [
            {statusPanel: 'agTotalRowCountComponent', align: 'left'},
            {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
            {statusPanel: 'agSelectedRowCountComponent'},
            {statusPanel: 'agAggregationComponent'},
          ],
        },
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
        suppressCopyRowsToClipboard: true,
        enableRangeSelection: true,
        enableCharts: true,

        onColumnRowGroupChanged: updateGridGroupPipeline,
        getContextMenuItems,
      }

      function openEmployerEditPage() {
        if (vm.selectedRowsLength === 1) {
          $window.open(
            `/admin/firm-management?action=edit&id=${vm.selectedRows[0].id}`,
            '_blank'
          )
        }
      }

      function onSelectionChanged() {
        vm.selectedRows = vm.gridOptions.api.getSelectedRows()
        vm.selectedRowsLength = vm.selectedRows.length
        hideShowDropdownActionItem()
      }

      function onFilterChanged() {
        vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length
        // eslint-disable-next-line angular/document-service
        let filterTextBoxValue = document.querySelector('#filter-text-box')
          .value
        if (filterTextBoxValue.length > 0) {
          vm.filterCount += 1
        }

        let temporaryFilter = JSON.stringify({
          status: {values: ['Active'], filterType: 'set'},
        })

        if (
          JSON.stringify(vm.gridOptions.api.getFilterModel()) === '{}' ||
          JSON.stringify(vm.gridOptions.api.getFilterModel()) ===
            temporaryFilter
        ) {
          $log.debug(
            'onFilterChanged',
            JSON.stringify(vm.gridOptions.api.getFilterModel())
          )
          vm.showClearFilter = false
        } else vm.showClearFilter = true
        updatePipelineCountFromGrid()
      }

      // TODO: on grid functionality
      function updatePipelineCountFromGrid() {
        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            vm.groupList.map(row => {
              if (row.id === node.id) {
                row.applicationsCount = node.allChildrenCount
                return row
              }

              return row
            })
          }
        })
        $scope.$applyAsync()
      }

      // TODO: on grid action items functionality
      function updateGridGroupPipeline() {
        vm.groupList = []

        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            let hasChild = true
            if (
              _.isEmpty(node.childrenMapped) ||
              'undefined' in node.childrenMapped
            )
              hasChild = false
            vm.groupList.push({
              name: node.key,
              applicationsCount: node.allChildrenCount,
              color: node.leafGroup
                ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                : lighten('#5e5e5e', (node.level + 1) * 10),
              id: node.id,
              intId: Number(node.id) * -1,
              level: node.level,
              parentID: node.parent.id,
              hasChild: hasChild,
              isHidden: node.level !== 0,
            })
          }
        })
        $log.debug('vm.groupList', vm.groupList)
        $scope.$applyAsync()
      }

      const hideShowDropdownActionItem = () => {
        vm.multiSelectOptions = undefined
        vm.gridDataActions = []
        if (vm.selectedRowsLength > 0) {
          const row = vm.gridOptions.api.getSelectedRows()
          vm.multiSelectOptions = [
            {
              count: vm.selectedRowsLength,
            },
            {
              funcName: 'Clear Selection',
              function: vm.clearSelection,
            },
          ]
          vm.gridDataActions = [
            {
              count: vm.selectedRowsLength,
            },
            {
              funcName: 'Edit Employer',
              function: vm.editEmployerModal,
              rightClick: openEmployerEditPage,
              funcParameter: row,
              visible: vm.selectedRowsLength === 1,
              icon: '/images/edit-pencil.svg',
            },
          ]
          $scope.$applyAsync()
        }

        $scope.$applyAsync()
      }

      function getContextMenuItems() {
        var result = [
          {
            name: 'Expand All Columns',
            action: function() {
              var columnApi = vm.gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                vm.gridOptions.columnApi.setColumnGroupOpened(
                  item.groupId,
                  true
                )
              })
            },
          },
          {
            name: 'Collapse All Columns',
            action: function() {
              var columnApi = vm.gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                vm.gridOptions.columnApi.setColumnGroupOpened(
                  item.groupId,
                  false
                )
              })
            },
          },
          'separator',
          'copy',
          'copyWithHeaders',
          'separator',
          'chartRange',
        ]
        vm.isExportAllowed = vm.user.roles.some(
          role => role.id === 'admin' || role.id === 'ops'
        )
        if (vm.isExportAllowed) result.push('export')
        return result
      }

      function openAddEmployerPage() {
        $window.open('/admin/firm-management?action=add', '_blank')
      }

      function openAddPositionPage() {
        $window.open('/admin/job-creation', '_blank')
      }

      const positionModal = id => {
        const modalInstance = $uibModal.open({
          templateUrl: 'create-update-position-modal.html',
          windowClass: 'app-firm-window',
          controller: 'CreateUpdatePositionModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedPositionId: function() {
              return id
            },
            adminId: function() {
              return vm.user.id
            },
          },
        })
        modalInstance.result.then(
          () => {
            modalInstance.dismiss('cancel')
          },
          () => {}
        )
      }

      function openEditEmployerModal(parameter) {
        if (parameter.data.id) {
          employerModal(parameter.data.id)
        }
      }

      function openNotesPage(parameter) {
        const employerName = encodeURIComponent(parameter.data.name)
        $window.open(
          `/admin/firm-notes?employer=${parameter.data.id}&employerName=${employerName}`,
          '_blank'
        )
      }

      vm.editEmployerModal = selectedRow => {
        const id = selectedRow.map(({id}) => id).join()
        employerModal(id)
      }

      const employerModal = id => {
        const modalInstance = $uibModal.open({
          templateUrl: 'create-update-employer-modal.html',
          windowClass: 'app-firm-window',
          controller: 'CreateUpdateEmployerModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedEmployerId: function() {
              return id
            },
          },
        })
        modalInstance.result.then(
          result => {
            modalInstance.dismiss('cancel')
            const selectedRows = vm.gridOptions.api.getSelectedRows()
            if (result.type === 'deleted') {
              vm.gridOptions.api.updateRowData({remove: selectedRows})
            }

            logger.notify(
              'success',
              `Employer Id: ${result.employer.id} ${result.employer.name} ${result.type} successfully`
            )
          },
          () => {}
        )
      }

      vm.gridOptions = gridOptions
      vm.gridName = 'employer'
      vm.filterCount = 0

      vm.actionsFunctions = [
        {
          funcName: 'Add Position',
          leftClick: positionModal,
        },
      ]
      vm.activeActions = [
        {
          funcName: 'Add Employer',
          function: employerModal,
          visible: true,
          icon: `/images/plus-icon.svg`,
        },
      ]
      var originalEmployersListing = []
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showClass = ''
      vm.showDropDown = () => {
        if (vm.showClass === '') {
          vm.showClass = 'show'
        } else {
          vm.showClass = ''
        }
      }

      vm.loadEmployersListing = employersRecord => {
        originalEmployersListing = setEmployersListingData(employersRecord)
        vm.employerListing = originalEmployersListing
        vm.gridOptions.api.setRowData(vm.employerListing)
        $rootScope.$broadcast('listing-loaded')

        $scope.$apply()
      }

      const setEmployersListingData = employersRecord => {
        return employersRecord.map(data => {
          let employerSelectivity = ''
          if (data.selectivity) {
            for (let index = 1; index <= data.selectivity; index++) {
              employerSelectivity += '$'
            }
          }

          if (data.selectivity === 0) employerSelectivity = 'Uncategorized'
          data.selectivity = employerSelectivity
          data.isVisible = data.isVisible ? 'Visible' : 'Invisible'
          data.category =
            data.specialties.length > 0
              ? vm.legalEmployerTypeList.specialties
                  .filter(({id}) =>
                    data.specialties.find(specialty => specialty.id === id)
                  )
                  .map(employerType => employerType.name)
                  .join()
              : data.approved
              ? ''
              : 'Auto-Generated'
          data.employerAgentEmail = data.agentId
            ? vm.agentsList.find(agent => agent.id === data.agentId)
              ? vm.agentsList.find(agent => agent.id === data.agentId).email
              : 'unassigned'
            : 'unassigned'
          if (data.logo)
            data.employerLogo = `${process.env.PUBLIC_BUCKET_URL}/employers/${data.id}/logo/${data.logo}`

          data.positionCount = Number(data.jobsCount)
          data.candidateEmployerCount = Number(data.candidateEmployerCount)

          return data
        })
      }

      vm.openEmployerCreationPage = () => {
        $window.open('/admin/firm-management?action=add', '_blank')
      }

      vm.openPositionCreationPage = () => {
        $window.open('/admin/job-creation', '_blank')
      }

      vm.updateSelectedEmployerAgent = async selectedAgent => {
        const selectedRow = vm.gridOptions.api.getSelectedRows()
        const selectedEmployerIds = selectedRow.map(x => x.id)
        const result = await updateEmployerAgentApi(
          selectedEmployerIds,
          selectedAgent.email,
          selectedRow
        )

        if (result === 200) {
          logger.notify(
            'success',
            selectedEmployerIds.length +
              ' employer' +
              (selectedEmployerIds.length > 1 ? 's' : '') +
              " assigned to '" +
              selectedAgent.email +
              "'"
          )
          vm.gridOptions.api.deselectAll()
          $('#agentsDropdownList').hide()
        }
      }

      async function onAgentChange(parameter) {
        if (parameter.newValue !== parameter.oldValue) {
          const employerId = [parameter.data.id]
          const selectedRow = [parameter.data]
          await updateEmployerAgentApi(
            employerId,
            parameter.newValue,
            selectedRow
          )
        }

        logger.notify(
          'success',
          `Employer Id: ${parameter.data.id} Agent ${parameter.newValue} updated successfully`
        )
      }

      const updateEmployerAgentApi = async (
        employerIds,
        selectedAgentEmail,
        selectedRow
      ) => {
        const agent =
          selectedAgentEmail === 'unassign'
            ? // eslint-disable-next-line unicorn/no-null
              {id: null, email: 'unassigned'}
            : vm.agentsList.find(({email}) => email === selectedAgentEmail)
        const payload = {employerIds, agentId: agent.id}
        try {
          const {status} = await EmployersApi.updateEmployerAssignedAgent(
            payload
          )
          if (status === 200) {
            selectedRow.map(row => {
              row.employerAgentEmail = agent.email
              return row
            })
            vm.gridOptions.api.updateRowData({update: selectedRow})
            return status
          }
        } catch (error) {
          logger.notify('error', error.data.message)
        }
      }

      const initializeEmployersListing = async () => {
        vm.user = await userService.getUser()

        const [
          {data: agentsList},
          {data: legalPracticeAreaList},
          {data: legalEmployerTypeList},
          employersListingRecords,
        ] = await Promise.all([
          CandidateProfileApi.getAdminAndCorporateUsers(),
          SharedApi.getCategoryById(1),
          SharedApi.getCategoryById(2),
          EmployersApi.getEmployerListing(),
        ])

        vm.agentsList = agentsList
        vm.legalPracticeAreaList = legalPracticeAreaList
        vm.legalEmployerTypeList = legalEmployerTypeList

        vm.gridActionsDirective = {
          assignAgent: {
            buttonId: 'assignee-admin-filter',
            agentsList: vm.agentsList,
            function: vm.updateSelectedEmployerAgent,
            filteredAgentList: vm.agentsList,
          },
        }

        const employersAgentsList = vm.agentsList.map(agent => agent.email)
        employersAgentsList.unshift('unassign')
        vm.gridOptions.columnDefs.find(
          column => column.field === 'employerAgentEmail'
        ).cellEditorParams.values = employersAgentsList
        vm.loadEmployersListing(employersListingRecords.data)
      }
    },
  ])
})()

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}



// WEBPACK FOOTER //
// ./scripts/admin-panel/employers-listing/employers-listing.ctrl.js